// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"465":"56ef5d07","498":"aee304b9","703":"e28aa6a1"}[chunkId] + ".chunk.js";
};